export const UPDATE_WHEEL_PRIZE = 'UPDATE_WHEEL_PRIZE';
export const UPDATE_WHEEL_SPIN_STATUS = 'UPDATE_WHEEL_SPIN_STATUS';
export const WHEEL_SPINNING = 'WHEEL_SPINNING';

export function updateWheelPrize(data) {
  return {
    type: UPDATE_WHEEL_PRIZE,
    data
  }
}

export function updateSpinStatus(data) {
  return {
    type: UPDATE_WHEEL_SPIN_STATUS,
    data
  }
}

export function wheelSpinning(data) {
  return {
    type: WHEEL_SPINNING,
    data
  }
}